import { createI18n } from '@next-box/i18n';
import { type DateArg, type FormatOptions, format } from 'date-fns';
import { content, dateLocale } from '#content/index.ts';

export const { t, tt } = createI18n(content);

export const formatDate = (date: DateArg<Date> & {}, formatStr: string, options?: FormatOptions) =>
  format(date, formatStr, { ...options, locale: dateLocale });
